import styled from '@emotion/styled';
import css from '@styled-system/css';
import PropTypes from 'prop-types';

import { OverlayFooter } from '../Overlay';

const DrawerFooter = styled(OverlayFooter)(
  css({
    width: '100%',
    boxShadow: '0',
    position: 'relative',
    marginTop: 'auto',
  })
);

DrawerFooter.propTypes = {
  children: PropTypes.any.isRequired,
};

export default DrawerFooter;
